import axios from "axios";
import { Message } from "element-ui";
import router from "../router";
export default {
  get(url, params) {
    if (!url.includes("http://")) {
      url = "server" + url;
    }

    //url = url;
    return new Promise((res, rej) => {
      try {
        axios({ method: "get", url, params }).then(data => {
          if (data.status == 200) {
            if (data.data.code) {
              if (data.data.code == 200) {
                res(data.data.result);
              } else if (data.data.code == 401) {
                Message({
                  type: "error",
                  message: data.data.msg || "请重新登录"
                });
                router.push("/");
              } else if (data.data.code == 403) {
                Message({
                  type: "error",
                  message: data.data.msg || "没有权限"
                });
              } else {
                Message({
                  type: "error",
                  message: data.data.msg || "请求失败"
                });
                rej(data.data.result);
              }
            } else {
              Message({
                type: "error",
                message: "请求异常"
              });
              res(data.data);
            }
          } else {
            rej(data);
          }
        });
      } catch (err) {
        rej(err);
      }
    });
  },
  post(url, data, headers = {}) {
    url = "server" + url;
    //url = url;
    return new Promise((res, rej) => {
      try {
        axios({ method: "post", url, data, headers }).then(data => {
          if (data.status == 200) {
            if (data.data.code) {
              if (data.data.code == 200) {
                res(data.data.result);
              } else if (data.data.code == 401) {
                Message({
                  type: "error",
                  message: data.data.msg || "请重新登录"
                });
                router.push("/");
              } else if (data.data.code == 403) {
                Message({
                  type: "error",
                  message: data.data.msg || "没有权限"
                });
              } else {
                Message({
                  type: "error",
                  message: data.data.msg || "请求失败"
                });
                rej(data.data.result);
              }
            } else {
              res(data.data);
            }
          } else {
            Message({
              type: "error",
              message: "请求异常"
            });
            rej(data);
          }
        });
      } catch (err) {
        rej(err);
      }
    });
  },

  postfile(url, data, headers = {}) {
    url = "file-server" + url;
    //url = url;
    return new Promise((res, rej) => {
      try {
        axios({ method: "post", url, data, headers }).then(data => {
          if (data.status == 200) {
            if (data.data.code) {
              if (data.data.code == 200) {
                res(data.data.result);
              } else if (data.data.code == 401) {
                Message({
                  type: "error",
                  message: data.data.msg || "请重新登录"
                });
                router.push("/");
              } else if (data.data.code == 403) {
                Message({
                  type: "error",
                  message: data.data.msg || "没有权限"
                });
              } else {
                Message({
                  type: "error",
                  message: data.data.msg || "请求失败"
                });
                rej(data.data.result);
              }
            } else {
              res(data.data);
            }
          } else {
            Message({
              type: "error",
              message: "请求异常"
            });
            rej(data);
          }
        });
      } catch (err) {
        rej(err);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/server/index.js